import * as React from "react";
import { FormMessage as FormMessageBase, FormMessageProps } from "@fluentui/react-northstar";
const FormMessage: React.FC<FormMessageProps> = (props: FormMessageProps) => {
  return <FormMessageBase {...props}></FormMessageBase>;
};
export default FormMessage;
